/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect } from 'react';
import {
  TextField,
  Button as MUIButton,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  Typography,
} from '@mui/material';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Delete } from '@mui/icons-material';
import { useStateContext } from '../contexts/ContextProvider';
import LoadingOverlay from '../components/LoadingOverlay';
import { variables } from '../components/Variables';

const RetailAddItem = ({ getRetailItemData, editData, show, onOpen, onClose }) => {
  const userInfo = !!localStorage.getItem('loginID')
    && JSON.parse(localStorage.getItem('loginID'));
  const [loading, setLoading] = useState(false);
  const [fieldDisable, setfieldDisable] = useState(false);
  const [showVendorModal, setShowVendorModal] = useState(false);
  const [itemData, setItemData] = useState({ itemId: '', qty: '' });
  const [items, setItems] = useState([]);
  const [vendorName, setVendorName] = useState('');
  const [errormsg, setError] = useState('');
  const [errors, setErrors] = useState({
    itemId: '',
    qty: '',
  });
  const { vendorList, setVendorList } = useStateContext();
  const { control, handleSubmit, getValues, setValue, clearErrors } = useForm({
    defaultValues: {
      vendor: null,
      vendorKitItem: '',
      desc: '',
      upc: '',
    },
  });

  const selectRef = useRef(null);
  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      setItemData({ itemId: '', qty: '' });
      setItems(editData.items);
      setValue('vendorKitItem', editData.VendorKitItem);
      setValue('desc', editData.Description);
      setValue('upc', editData.UPC);
      const selectedVendor = vendorList.find(
        (v) => v.value === editData.Vendor,
      );
      setValue('vendor', selectedVendor || null);
      setfieldDisable(true);
    }
  }, [editData]);

  const handleItemChange = (e) => {
    setItemData({ ...itemData, [e.target.name]: e.target.value.trim().toUpperCase() });
  };
  const checkItemId = async () => {
    const exists = items.some((row) => row.itemId.toUpperCase() === itemData.itemId.toUpperCase());
    const { vendorKitItem, vendor } = getValues();
    console.log(vendorKitItem === '', vendor === '');
    if (vendorKitItem === '' || vendor === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Please select Vendor and enter Vendor KitItem first.',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setItemData((prev) => ({
            ...prev,
            itemId: '',
          }));
          setTimeout(() => {
            if (vendor === '') {
              selectRef.current?.focus();
            } else if (vendorKitItem === '') {
              document.getElementById('vendorKitItem_id')?.focus();
            }
          }, 300);
        }
      });
      return;
    }
    if (exists) {
      Swal.fire({
        icon: 'warning',
        title: 'Duplicate Item',
        text: `Item ID "${itemData.itemId}" is already added.`,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setItemData((prev) => ({
            ...prev,
            itemId: '',
          }));
          setTimeout(() => {
            document.getElementById('itemIdField')?.focus();
          }, 200);
        }
      });
      return;
    }
    if (itemData.itemId !== '') {
      if (itemData.itemId.trim().length > 31) {
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'The Max lenght for itemId is 31.',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            setItemData((prev) => ({
              ...prev,
              itemId: '',
            }));
            setTimeout(() => {
              document.getElementById('itemIdField')?.focus();
            }, 200);
          }
        });
        return;
      }
      setLoading(true);
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Retail Item Master',
        ITEMID: itemData.itemId || '',
      };
      try {
        const response = await axios.post(
          `${variables.BASE_URL}ValidateSKU`,
          data,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        const Data = response.data;
        if (!Data.IsSuccess) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: Data.Reason,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              setItemData((prev) => ({
                ...prev,
                itemId: '',
              }));
              setTimeout(() => {
                document.getElementById('itemIdField')?.focus();
              }, 300);
            }
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error,
          allowOutsideClick: false,
        });
      } finally {
        setLoading(false);
      }
    }
  };
  const checkQty = () => {
    if (parseInt(itemData.qty, 10) === 0 || itemData.qty > 99) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Quantity must be between 1 and 99.',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setItemData((prev) => ({
            ...prev,
            qty: '',
          }));
          setTimeout(() => {
            document.getElementById('qty_id')?.focus();
          }, 200);
        }
      });
    }
  };

  const handleAddRow = () => {
    let hasError = false;
    const newErrors = { itemId: '', qty: '' };
    if (!itemData.itemId.trim()) {
      newErrors.itemId = 'Item ID is required';
      hasError = true;
    }
    if (!itemData.qty.trim()) {
      newErrors.qty = 'Quantity is required';
      hasError = true;
    }
    setErrors(newErrors);
    if (hasError) return; // stop if any error
    if (itemData.itemId && itemData.qty) {
      setItems([...items, { ...itemData }]);
      setItemData({ itemId: '', qty: '' });
    }
  };

  const checkKitItem = async () => {
    const { vendorKitItem, vendor } = getValues();
    if (!vendor) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select Vendor first.',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setValue('vendorKitItem', '');
          setTimeout(() => {
            selectRef.current?.focus();
          }, 300);
        }
      });
      return;
    }
    if (vendorKitItem?.trim() !== '') {
      if (vendorKitItem?.trim().length > 26) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'The Vendor KitItem must be less than or equal to 26 characters.',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            setValue('vendorKitItem', '');
            setTimeout(() => {
              document.getElementById('vendorKitItem_id').focus();
            }, 300);
          }
        });
        return;
      }

      setLoading(true);
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Retail Item Master',
        Vendor: vendor?.value,
        kititem: vendorKitItem?.trim(),
      };
      try {
        const response = await axios.post(
          `${variables.BASE_URL}ValidateVendorKitItems`,
          data,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        const Data = response.data;
        if (!Data.IsSuccess) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: Data.Reason,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              setValue('vendorKitItem', '');
              setTimeout(() => {
                document.getElementById('vendorKitItem_id').focus();
              }, 300);
            }
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            setValue('vendorKitItem', '');
            setTimeout(() => {
              document.getElementById('vendorKitItem_id').focus();
            }, 300);
          }
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const RetailSubmit = () => {
    document.getElementById('RetailSubmit_id').click();
  };

  const onSubmit = async (data) => {
    if (items.length > 0) {
      setLoading(true);
      const ReqData = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Retail Item Master',
        Id: editData && Object.keys(editData).length > 0 ? editData.ID : '',
        Vendor: data.vendor.value,
        VendorKitItem: data.vendorKitItem?.trim(),
        UPC: data.upc,
        Description: data.desc,
        ActionType: editData && Object.keys(editData).length > 0 ? 'EDIT' : 'INSERT',
        // ActionType: 'INSERT',
        Type_RetailSKUKit_SaveDetails: items,
      };
      try {
        const response = await axios.post(
          `${variables.BASE_URL}RetailSaveData`,
          ReqData,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        const Data = response.data;
        if (Data.IsSuccess) {
          Swal.fire({
            icon: 'success',
            title: 'Done',
            text: Data.Reason,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              closeModal();
              getRetailItemData();
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: Data.Reason,
            allowOutsideClick: false,
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error,
          allowOutsideClick: false,
        });
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Please add ItemID and Qty in table.',
        allowOutsideClick: false,
      });
    }
  };
  const closeModal = () => {
    Clearall();
    onClose();
    setErrors({
      itemId: '',
      qty: '',
    });
  };
  const Clearall = () => {
    setItemData({ itemId: '', qty: '' });
    setItems([]);
    setValue('vendorKitItem', '');
    setValue('vendor', '');
    setValue('desc', '');
    setValue('upc', '');
    setfieldDisable(false);
    clearErrors(['vendorKitItem', 'vendor', 'desc', 'upc']);
  };

  // const AddnewVendor = () => {
  //   debugger
  //   const trimmedName = vendorName.trim();
  //   if (!trimmedName) {
  //     setError('Vendor Name is required');
  //     return;
  //   }
  //   // check for duplicate (case-insensitive)
  //   const isDuplicate = vendorList.some(
  //     (vendor) => vendor.value.toLowerCase() === trimmedName.toLowerCase(),
  //   );

  //   if (isDuplicate) {
  //     setError('Vendor already exists, please select from vendor list.');
  //     return;
  //   }

  //   setVendorList([
  //     ...vendorList,
  //     { label: trimmedName, value: trimmedName },
  //   ]);

  //   setError('');
  //   setVendorName('');
  //   setShowVendorModal(false);
  // };
  const AddnewVendor = () => {
    const trimmedName = vendorName.trim();
    if (!trimmedName) {
      setError('Vendor Name is required');
      return;
    }

    // check for duplicate (case-insensitive)
    const isDuplicate = vendorList.some(
      (vendor) => vendor.value.toLowerCase() === trimmedName.toLowerCase(),
    );

    if (isDuplicate) {
      setError('Vendor already exists, please select from vendor list.');
      return;
    }

    const newVendor = { label: trimmedName, value: trimmedName };

    // update vendor list
    setVendorList((prev) => [...prev, newVendor]);

    // ✅ set newly added vendor as selected in Select
    setValue('vendor', newVendor);

    // optional: reset errors and close modal
    setError('');
    setVendorName('');
    setShowVendorModal(false);
  };

  const ValidateDesc = () => {
    const { desc } = getValues();
    if (desc.length > 101) {
      Swal.fire({
        icon: 'warning',
        title: 'Opps..',
        text: 'The Max lenght for Description is 101.',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setValue('desc', '');
          document.getElementById('desc_id').focus();
        }
      });
    }
  };
  const ValidateUpc = () => {
    const { upc } = getValues();
    if (upc.length > 12) {
      Swal.fire({
        icon: 'warning',
        title: 'Opps..',
        text: 'The Max lenght for UPC is 12.',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setValue('upc', '');
          document.getElementById('upc_id').focus();
        }
      });
    }
  };
  const DeleteSKU = (index) => {
    const itemToDelete = items[index];
    const updatedItems = items.filter((_, i) => i !== index);
    console.log(itemToDelete);
    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to Delete the ItemID: ${itemToDelete.itemId} and Qty: ${itemToDelete.qty}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setItems(updatedItems);
      }
    });
  };
  const handleVendorChange = (selected, field) => {
    const { vendorKitItem } = getValues();
    if (vendorKitItem) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to change the Vendor! This will reset all fields.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!',
      }).then((result) => {
        if (result.isConfirmed) {
          field.onChange(selected); // update vendor
          setValue('vendorKitItem', ''); // reset vendorKitItem
          setValue('desc', '');
          setValue('upc', '');
          clearErrors('vendorKitItem'); // optional: clear error msg
          setItems([]); // clear items
        }
      });
    } else {
      field.onChange(selected); // update vendor
      setValue('vendorKitItem', ''); // reset vendorKitItem
      setValue('desc', '');
      setValue('upc', '');
      clearErrors('vendorKitItem'); // optional: clear error msg
    }
  };

  return (
    <>
      {/* Button to Open Modal */}
      <Button variant="primary" onClick={onOpen}>
        Add Retail SKU
      </Button>
      {/* Modal */}
      <Modal
        show={show}
        onHide={closeModal}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="modal-90w"
      >
        <Modal.Header
          closeButton
          style={{
            background: 'linear-gradient(90deg, #093FB4,#C0C9EE, #FFFCFB)',
            color: '#fff',
          }}
        >
          <Modal.Title>Add Retail SKU</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: '#FFFCFB' }}>
          <Grid container spacing={3} style={{ padding: '10px' }}>
            {/* Left Section - 60% */}
            <Grid item xs={12} md={7}>
              <Paper className="p-3" style={{ borderRadius: '12px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={2}>
                    {/* Vendor Select with react-select */}
                    <Grid item xs={4}>
                      <FormControl fullWidth size="small">
                        <Controller
                          name="vendor"
                          control={control}
                          rules={{ required: 'Vendor is required' }}
                          render={({ field, fieldState: { error } }) => (
                            <>
                              <Select
                                {...field}
                                ref={selectRef}
                                options={vendorList}
                                placeholder="Select Vendor"
                                id="Vendordrop_id"
                                isDisabled={fieldDisable}
                                onChange={(selected) => handleVendorChange(selected, field)}
                              />
                              {error && (
                              <span style={{ color: 'red', fontSize: '12px' }}>
                                {error.message}
                              </span>
                              )}
                            </>
                          )}
                        />
                      </FormControl>
                    </Grid>
                    {/* Add Vendor Button */}
                    <Grid item xs={3}>
                      <MUIButton
                        variant="contained"
                        color="secondary"
                        onClick={() => setShowVendorModal(true)}
                        fullWidth
                        disabled={fieldDisable}
                      >
                        Add New Vendor
                      </MUIButton>
                    </Grid>
                    {/* Vendor Kit Item */}
                    <Grid item xs={5}>
                      <Controller
                        name="vendorKitItem"
                        control={control}
                        rules={{
                          required: 'Vendor Kit Item is required',
                        }}
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            id="vendorKitItem_id"
                            autoComplete="off"
                            {...field}
                            label="Vendor Kit Item"
                            variant="outlined"
                            size="small"
                            fullWidth
                            onBlur={checkKitItem}
                            disabled={fieldDisable}
                            error={!!error}
                            helperText={error ? error.message : ''}
                            onChange={(e) => {
                              const { value } = e.target;
                              // Allow only alphabets, numbers, and hyphen
                              const filtered = value.replace(/[^a-zA-Z0-9-]/g, '');
                              field.onChange(filtered.toUpperCase());
                            }}
                          />
                        )}
                      />
                    </Grid>
                    {/* Description */}
                    <Grid item xs={6}>
                      <Controller
                        name="desc"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            id="desc_id"
                            autoComplete="off"
                            {...field}
                            label="Description"
                            onBlur={ValidateDesc}
                            variant="outlined"
                            size="small"
                            fullWidth
                            error={!!error}
                            helperText={error ? error.message : ''}
                          />
                        )}
                      />
                    </Grid>

                    {/* UPC */}
                    <Grid item xs={6}>
                      {/* <Controller
                        name="upc"
                        control={control}
                        render={({ field }) => (
                          <TextField
                            autoComplete="off"
                            {...field}
                            label="UPC"
                            onBlur={ValidateUpc}
                            variant="outlined"
                            size="small"
                            fullWidth
                          />
                        )}
                      /> */}
                      <Controller
                        name="upc"
                        control={control}
                        rules={{
                          required: 'UPC is required',
                        }}
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            autoComplete="off"
                            {...field}
                            id="upc_id"
                            label="UPC"
                            onBlur={ValidateUpc}
                            variant="outlined"
                            size="small"
                            fullWidth
                            onChange={(e) => {
                              const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                              field.onChange(onlyNums);
                            }}
                            error={!!error}
                            helperText={error ? error.message : ''}
                          />
                        )}
                      />

                    </Grid>
                    {loading ? <LoadingOverlay /> : (
                      <Grid item xs={12} sx={{ display: 'none' }}>
                        <MUIButton id="RetailSubmit_id" type="submit" variant="contained" color="primary">
                          Submit
                        </MUIButton>
                      </Grid>
                    ) }

                  </Grid>
                </form>

                {/* Table below the form */}
                <TableContainer component={Paper} className="mt-4">
                  <Table size="small">
                    <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableRow>
                        <TableCell><strong>Item ID</strong></TableCell>
                        <TableCell><strong>Qty</strong></TableCell>
                        <TableCell><strong>Action</strong></TableCell> {/* ✅ new column */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.itemId}</TableCell>
                          <TableCell>{item.qty}</TableCell>
                          <TableCell>
                            <MUIButton
                              startIcon={<Delete />}
                              variant="outlined"
                              color="error"
                              size="small"
                              onClick={() => DeleteSKU(index)}
                            >
                              Delete
                            </MUIButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

              </Paper>
            </Grid>

            {/* Right Section - 40% */}
            <Grid item xs={12} md={5}>
              <Paper className="p-3" style={{ borderRadius: '12px' }}>
                <Typography variant="h6">SKU Details</Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={5}>
                    {/* <TextField
                      autoComplete="off"
                      id="itemIdField"
                      label="Item ID"
                      name="itemId"
                      value={itemData.itemId}
                      onChange={handleItemChange}
                      onBlur={checkItemId}
                      variant="outlined"
                      size="small"
                      fullWidth
                    /> */}
                    <TextField
                      autoComplete="off"
                      id="itemIdField"
                      label="Item ID"
                      name="itemId"
                      value={itemData.itemId}
                      onChange={(e) => {
                        handleItemChange(e);
                        setErrors((prev) => ({ ...prev, itemId: '' })); // clear error on change
                      }}
                      onBlur={checkItemId}
                      variant="outlined"
                      size="small"
                      fullWidth
                      error={!!errors.itemId}
                      helperText={errors.itemId}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    {/* <TextField
                      id="qty_id"
                      autoComplete="off"
                      label="Qty"
                      name="qty"
                      value={itemData.qty}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // keep only digits
                        handleItemChange({ target: { name: 'qty', value } });
                      }}
                      onBlur={checkQty}
                      variant="outlined"
                      size="small"
                      fullWidth
                    /> */}
                    <TextField
                      id="qty_id"
                      autoComplete="off"
                      label="Qty"
                      name="qty"
                      value={itemData.qty}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // keep only digits
                        handleItemChange({ target: { name: 'qty', value } });
                        setErrors((prev) => ({ ...prev, qty: '' })); // clear error on change
                      }}
                      onBlur={checkQty}
                      variant="outlined"
                      size="small"
                      fullWidth
                      error={!!errors.qty}
                      helperText={errors.qty}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <MUIButton
                      variant="contained"
                      color="secondary"
                      onClick={handleAddRow}
                      fullWidth
                    >
                      Add
                    </MUIButton>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Modal.Body>

        <Modal.Footer style={{ gap: 15 }}>
          <MUIButton
            variant="contained"
            color="primary"
            onClick={RetailSubmit}
            sx={{ borderRadius: '8px', px: 3 }}
          >
            Submit
          </MUIButton>
          <MUIButton
            variant="outlined"
            color="error"
            onClick={closeModal}
            sx={{ borderRadius: '8px', px: 3 }}
          >
            Close
          </MUIButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showVendorModal}
        onHide={() => {
          setVendorName('');
          setError('');
          setShowVendorModal(false);
        }}
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{
            background: 'linear-gradient(90deg, #4e54c8, #8f94fb)',
            color: '#fff',
          }}
        >
          <Modal.Title>Add Vendor Details</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ background: '#fafafa' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="off"
                fullWidth
                label="Vendor Name"
                name="vendorName"
                variant="outlined"
                size="small"
                value={vendorName}
                onChange={(e) => {
                  if (e.target.value.length <= 50) {
                    setVendorName(e.target.value);
                    setError('');
                  } else {
                    setError('The Max lenght for Vendor is 50.');
                    // Swal.fire({
                    //   icon: 'warning',
                    //   title: 'Opps..',
                    //   text: 'The Max lenght for Vendor is 50.',
                    //   // allowOutsideClick: false,
                    // });
                  }
                }}
                error={Boolean(errormsg)}
                helperText={errormsg}
                autoFocus
              />
            </Grid>
          </Grid>
        </Modal.Body>

        <Modal.Footer style={{ background: '#fafafa', gap: 15 }}>
          <MUIButton
            variant="contained"
            color="primary"
            onClick={AddnewVendor}
            sx={{ borderRadius: '8px', px: 3 }}
          >
            Submit
          </MUIButton>
          <MUIButton
            variant="outlined"
            color="error"
            onClick={() => {
              setVendorName('');
              setError('');
              setShowVendorModal(false);
            }}
            sx={{ borderRadius: '8px', px: 3 }}
          >
            Cancel
          </MUIButton>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default RetailAddItem;
